import { render, staticRenderFns } from "./PageRoleManagement.vue?vue&type=template&id=71ecb062&scoped=true"
import script from "./PageRoleManagement.vue?vue&type=script&lang=js"
export * from "./PageRoleManagement.vue?vue&type=script&lang=js"
import style0 from "./PageRoleManagement.vue?vue&type=style&index=0&id=71ecb062&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ecb062",
  null
  
)

export default component.exports